<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [style]="{ width: '90vw', height: '90vh' }"
  [closable]="false"
  (onHide)="cancel()"
>
  <ng-template pTemplate="header">
    <h3>Behörde bearbeiten</h3>
  </ng-template>

  <ng-template pTemplate="content">
    <form class="p-fluid mb-2">
      <div class="field">
        <p-inputgroup>
          <p-iftalabel>
            <label for="name">{{ 'competentAuthority.dialog.name' | transloco }}</label>
            <input id="name" type="text" pInputText [(ngModel)]="authority.name" name="name" required/>
          </p-iftalabel>
        </p-inputgroup>
      </div>
    </form>
    <app-choose-contact
      [onlyEditContact]="true"
      [newContact]="newContact"
      (newContactUpdated)="onSetNewContact($event)"
      (validationStatusChanged)="validationStatusChanged = $event"
      [allowEmptyValid]="true"
    />
  </ng-template>

  <ng-template pTemplate="footer">
    <div class="flex gap-2">
      <p-button
        (click)="cancel()"
        icon="pi pi-times"
        [text]="true"
        label="{{ 'modal.cancel' | transloco }}"
      />
      <p-button
        [disabled]="!authority.name.trim() && validationStatusChanged"
        (click)="update()"
        icon="pi pi-save"
        label="{{ 'modal.save' | transloco }}"
      />
    </div>
  </ng-template>
</p-dialog>
